import { Dropdown } from 'antd';
import { CategoryTopic } from 'src/interface';

import DropdownMenu from './DropdownMenu';
import cn from "src/utils/cn";

type Props = {
	activeKey: any;
	onChange: (v: any) => void;
	categoryTopics: any;
	keyTopic: any;
};

const TabMenu = (props: Props) => {
	const { activeKey, onChange, categoryTopics, keyTopic } = props;

	return (
		<div className="mb-[24px] md:mb-[32px] lg:mb-[40px]">
			<div className="w-full inline-flex whitespace-nowrap overflow-x-auto [&::-webkit-scrollbar]:hidden">
				{categoryTopics?.slice(0, keyTopic)?.map((categoryTopic: CategoryTopic, id: number) => {
					const key = `${id + 1}__${categoryTopic.slug}`;
					const isActiveKey = key === activeKey;

					return (
						<div
							key={key}
							className={cn('mr-[12px] md:mr-[24px]', { 'border-b-2 border-primary': isActiveKey })}
							onClick={() => onChange({ key })}
						>
							<h2 className={cn('cursor-pointer font-semibold mb-0 pb-[4px] md:pb-[8px] text-[14px] leading-[18px] md:text-[16px] xl:leading-[21px] lg:text-[18px] 2xl:leading-[25px] transition-colors', { 'text-primary': isActiveKey, 'text-neutral-5 hover:text-primary': !isActiveKey })}>{categoryTopic?.name}</h2>
						</div>
					);
				})}

				{categoryTopics?.length > keyTopic && (
					<Dropdown
						popupRender={() => (
							<DropdownMenu
								menu={categoryTopics}
								active={activeKey}
								onChangeFn={onChange}
								keyTopic={keyTopic}
							/>
						)}
						trigger={['click']}
						placement="bottomRight"
						arrow
					>
						<div
							className={cn('cursor-pointer font-semibold mb-0 pb-[4px] md:pb-[8px] text-[14px] leading-[18px] md:text-[16px] xl:leading-[21px] lg:text-[18px] 2xl:leading-[25px] flex items-center after:content-[url(/icons/down-arrow.svg)] after:ml-[10px] transition-colors', {
								'text-primary border-b-2 border-primary': activeKey?.split('__')?.[0] > keyTopic,
								'text-neutral-5 hover:text-primary': !(activeKey?.split('__')?.[0] > keyTopic),
							})}
							onClick={(e) => e.preventDefault()}
						>
							Lainnya
						</div>
					</Dropdown>
				)}
			</div>
		</div>
	);
};

export default TabMenu;
